export default __webpack_public_path__ + "static/media/community-events.18c3598c.png";